// sort-imports-ignore
import "@webcomponents/webcomponentsjs";
import "lit-element/polyfill-support.js";
import "./custom-elements-get-name.js";
import "core-js/actual";
import "@formatjs/intl-listformat/polyfill.js";
import "@formatjs/intl-listformat/locale-data/en.js";
